import React, { useState, useEffect, useRef } from 'react';
import ChronusApi from '../../../../../services/ChronusApi';
import RsvpReminder from './RsvpReminder';
import i18n from '../../../../../utils/ChrI18n';
import { useSelector, useDispatch } from '../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../chronusStore/slice/eventsListing';
import { ChrLoader } from '../../../../../utils/GeneralUtils';
import { keyBoardAccessibilityAttributes } from '../../../../../utils/GeneralUtils';
import ChrModal from '../../../../generic/Utils/ChrModal';
import ConfettiModalContent from '../RegisterButton/ConfettiModalContent';

const RsvpInfo = ({
  header, eventId, inviteUpdateUrl,
  showLoaderOnUpdate, buttons, reminderDetails,
  useAjaxApi, setReminderForStatus, children
}) => {
  const dispatch = useDispatch();
  const currentRsvpStatus = useSelector(state => state.eventsListing.eventIdRsvpStatusMap[eventId]);
  const [selectedStatus, setSelectedStatus] = useState(
    buttons.find(button => button.selected)?.status
  );
  const [modalContent, setModalContent] = useState();

  useEffect(() => {
    // Synchronize selectedStatus with currentRsvpStatus in store if different
    if(currentRsvpStatus !== undefined && currentRsvpStatus !== selectedStatus)
      setSelectedStatus(currentRsvpStatus);
  }, [currentRsvpStatus]);

  useEffect(() => {
    // Dispatch updateEventIdRsvpStatusMap action if selectedStatus changes and is different from currentRsvpStatus
    if(selectedStatus !== undefined && currentRsvpStatus !== selectedStatus)
      dispatch(eventsListingActions.updateEventIdRsvpStatusMap({ eventId, rsvpStatus: selectedStatus }));
  }, [selectedStatus]);

  const handleButtonClick = (status) => {
    if(showLoaderOnUpdate) ChrLoader.show();

    if(useAjaxApi)
      ChronusApi.getUrlJS(inviteUpdateUrl, { status });
    else
      ChronusApi.getUrlJSON(inviteUpdateUrl, { status }).then(response => {
        if(response.message) ChronusValidator.ErrorManager.ShowResponseFlash('', response.message, response.success)

        if(response.success){
          dispatch(eventsListingActions.updateRefreshCalendar(true));

          if(response.confettiModalContent) {
            setModalContent(response.confettiModalContent);
          }

          if(status === setReminderForStatus)
            dispatch(eventsListingActions.updateEventIdReminderMap({ eventId, reminder: true }));
        }
        else
          setSelectedStatus(currentRsvpStatus);
      }).catch(_error => {
        ChronusValidator.ErrorManager.ShowPageFlash(false, i18n.t("common_text.error_msg.something_went_wrong"));
      });

    setSelectedStatus(status);
  };

  const isButtonSelected = button => (button.status === selectedStatus);
  const canShowReminder = () => buttons.find(button => !button.disabled && isButtonSelected(button))?.showReminder;

  return (
    <>
      {
        modalContent && <ChrModal hideHeader={ true } show={ true }>
          <ConfettiModalContent modalContent={ modalContent } onClose={ () => setModalContent() } />
        </ChrModal>
      }

      {
        buttons &&
          <div className='d-flex flex-md-row flex-column flex-wrap'>
            <div className='d-flex flex-column'>
              {
                header && <div className='font-weight-bolder my-2'>{ header }</div>
              }
              <div>
                {
                  buttons.map(button => (
                    <a
                      key={ button.status }
                      onClick={ () => { inviteUpdateUrl && handleButtonClick(button.status) } }
                      disabled={ button.disabled }
                      className={ `btn btn-rounded-5 mr-2 border-bottom shadow-none waves-effect ${isButtonSelected(button) ? "cui-btn-light-blue active" : "btn-white"}` }
                      { ...keyBoardAccessibilityAttributes }
                    >
                      { button.label }
                    </a>
                  ))
                }
              </div>
              {
                reminderDetails &&
                  <div className={ canShowReminder() ? '' : 'hide' }>
                    <RsvpReminder { ...reminderDetails } eventId={ eventId }/>
                  </div>
              }
            </div>
            {
              children &&
                <div className='d-md-flex flex-md-fill flex-md-row-reverse'>
                  { children }
                </div>
            }
          </div>
      }
    </>
  )
};

export default RsvpInfo;